module.exports = __webpack_public_path__ + "img/nicky-pro.e1ccd1ce.jpg";